import LongText from '../Elements/LongText';
import datetimeHelper from '../Helpers/datetimeHelper';
import JsxHelper from '../Helpers/JsxHelper';
import React from 'react';

export default class TpEvaluatorPersonaItem {
  constructor(item) {
    if (item == null) {
      this.ThirdPartyEvaluatorIds = 0;
      this.AccountStatus = '';
      this.ThirdPartySource = '';
      this.City = '';
      this.State = '';
      this.ZipCode = '';
      this.CountryName = '';
      this.Gender = '';
      this.Birthday = '';
      this.LastRating = '';
      this.AvgRating = '';
      this.ProfileLanguage = '';
      this.EmailVerified = '';
      this.EmailOptOut = '';
      this.SignDate = '';
      this.LastLogin = '';
      this.AllShopsCountLastNDays = 0;
      this.ExcludedShopsCountLastNDays = 0;
      this.ExcludedPSShopsCountLastNDays = 0;
      this.FinalizedLockedShopsCountLastNDays = 0;
      this.ReferralClientShopsCountLastNDays = 0;
      this.LastShop = '';
      this.SpokenLanguage = '';
      this.Citizenship = '';
      return;
    }
    this.ThirdPartyEvaluatorIds = item.thirdPartyEvaluatorIds ? item.thirdPartyEvaluatorIds.join(', ') : '';
    this.AccountStatus = item.accountStatus;
    this.ThirdPartySource = item.thirdPartySources ? item.thirdPartySources.join(', ') : '';
    this.City = item.city;
    this.State = item.state;
    this.ZipCode = item.zipCode;
    this.CountryName = item.countryName;
    this.Gender = item.gender;
    this.Birthday = datetimeHelper.toYYYYsMMsDD(item.birthday);
    this.LastRating = item.lastRating;
    this.AvgRating = item.avgRating;
    this.ProfileLanguage =
      (item.profileLanguages && item.profileLanguages.length === 1) || !item.apolloLanguage
        ? item.profileLanguages?.join(', ')
        : item.apolloLanguage;
    this.EmailVerified = item.emailVerified;
    this.EmailOptOut = item.emailOptOut;
    this.SignDate = datetimeHelper.toYYYYsMMsDD(item.signDate);
    this.LastLogin = item.lastLogin;
    this.AllShopsCountLastNDays = item.allShopsCountLastNDays;
    this.ExcludedShopsCountLastNDays = item.excludedShopsCountLastNDays;
    this.ExcludedPSShopsCountLastNDays = item.excludedPSShopsCountLastNDays;
    this.FinalizedLockedShopsCountLastNDays = item.finalizedLockedShopsCountLastNDays;
    this.ReferralClientShopsCountLastNDays = item.referralClientShopsCountLastNDays;
    this.LastShop = datetimeHelper.toYYYYsMMsDD(item.lastShop);
    this.SpokenLanguage =
      (item.spokenLanguages && item.spokenLanguages.length === 1) || !item.apolloLanguage
        ? item.spokenLanguages?.join(', ')
        : item.apolloLanguage;
    this.Citizenship = item.citizenship;
  }

  static NameOfTheIdField() {
    return 'ThirdPartyEvaluatorIds';
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Platform ID', orderById: 'ThirdPartyEvaluatorIds', data: 'ThirdPartyEvaluatorIds', minWidth: '100px' },
      {
        label: 'Source',
        orderById: 'ThirdPartySource',
        data: (item) => (
          <LongText
            text={item.ThirdPartySource}
            maxLength={30}
          />
        ),
        minWidth: '120px',
      },
      { label: 'Account Status', orderById: 'AccountStatus', data: 'AccountStatus', minWidth: '120px' },
      { label: 'City', orderById: 'City', data: 'City' },
      { label: 'State', orderById: 'State', data: 'State' },
      { label: 'ZIP', orderById: 'ZipCode', data: 'ZipCode' },
      { label: 'Country', orderById: 'CountryName', data: 'CountryName' },
      { label: 'Gender', orderById: 'Gender', data: 'Gender' },
      { label: 'Birthday', orderById: 'Birthday', data: 'Birthday' },
      { label: 'Last Rating', orderById: 'LastRating', data: 'LastRating' },
      { label: 'Avg Rating', orderById: 'AvgRating', data: 'AvgRating' },
      {
        label: 'Profile Language',
        orderById: 'ProfileLanguage',
        data: (item) => (
          <LongText
            text={item.ProfileLanguage}
            maxLength={30}
          />
        ),
      },
      {
        label: 'Email Verified',
        orderById: 'EmailVerified',
        data: (item) => JsxHelper.YesNoEmpty(item.EmailVerified, true, false),
      },
      {
        label: 'Opted out from emails?',
        orderById: 'EmailOptOut',
        data: (item) => JsxHelper.YesNoEmpty(item.EmailOptOut, true, false),
      },
      { label: 'Sign-up Date', orderById: 'SignDate', data: 'SignDate' },
      { label: 'Last Login Date', orderById: 'LastLogin', data: 'LastLogin' },
      { label: 'All Shops In n Days #', orderById: 'AllShopsCountLastNDays', data: 'AllShopsCountLastNDays' },
      {
        label: 'Excluded Shops In n Days #',
        orderById: 'ExcludedShopsCountLastNDays',
        data: 'ExcludedShopsCountLastNDays',
        minWidth: 110,
      },
      {
        label: 'Excluded PS In n Days #',
        orderById: 'ExcludedPSShopsCountLastNDays',
        data: 'ExcludedPSShopsCountLastNDays',
        minWidth: 110,
      },
      {
        label: 'Client Delivered Shops In n Days #',
        orderById: 'FinalizedLockedShopsCountLastNDays',
        data: 'FinalizedLockedShopsCountLastNDays',
      },
      {
        label: 'Referral Client Shops In n Days #',
        orderById: 'ReferralClientShopsCountLastNDays',
        data: 'ReferralClientShopsCountLastNDays',
        minWidth: 120,
      },
      { label: 'Last Shop Date', orderById: 'LastShop', data: 'LastShop' },
      {
        label: 'Languages Fluent In',
        orderById: 'SpokenLanguage',
        data: (item) => (
          <LongText
            text={item.SpokenLanguage}
            maxLength={30}
          />
        ),
      },
      {
        label: 'Citizenship',
        orderById: 'Citizenship',
        data: 'Citizenship',
      },
      // {
      //   label: 'Motorized Vehicle Type',
      //   orderById: 'VehicleBrand',
      //   data: 'VehicleBrand',
      // },
      // {
      //   label: 'Tablet',
      //   orderById: 'Tablet',
      //   data: 'Tablet',
      // },
    ];
  }
}
